import { defaultHttpClient } from '../../httpClient';
import type { AssistantInfoResponse } from '../types';

export const getAssistantInfo = async (params: { query: string }) => {
  return defaultHttpClient
    .request<AssistantInfoResponse>({
      method: 'GET',
      url: '/api/v2/search/check_spell/',
      params,
    })
    .then(result => result.data);
};
